// Client-side mirror of Flows::PledgeStart (app/services/flows/pledge_start.rb) -- the server
// re-derives and enforces all of this; these only drive what the pledge/review steps show.
// `today` is the server's date (data-today on the pledge step), not the browser's, so both agree on
// which month is "this month" and which day of the month the pledge starts on.

const monthIndex = (year, month) => (year * 12) + month

// 1 = next month; 0 or less = this month or earlier.
export function monthsAhead({ month, year, today }) {
  return monthIndex(year, month) - monthIndex(today.getFullYear(), today.getMonth() + 1)
}

export function pledgeStartError({ month, year, today, maxYearsAhead }) {
  if (!month && !year) return null
  if (!month || !year) return "Choose both a month and a year for your pledge to start."

  const ahead = monthsAhead({ month, year, today })
  if (ahead < 1) return "Your pledge can start next month at the earliest."
  if (ahead > maxYearsAhead * 12) return `Your pledge can start up to ${maxYearsAhead} years from now.`
  return null
}

// Today's day of the chosen month, or that month's last day when it's shorter (Jan 31 -> Feb 28).
export function pledgeStartDate({ month, year, today }) {
  const lastDay = new Date(year, month, 0).getDate()
  return new Date(year, month - 1, Math.min(today.getDate(), lastDay))
}

// A meantime donation's tip: the same percentage of it that the pledge's tip is of the pledge.
export function scaledTipCents({ tipCents, planAmountCents, trialAmountCents }) {
  if (!planAmountCents) return 0
  return Math.round((tipCents * trialAmountCents) / planAmountCents)
}

// What checkout charges today: the first pledge payment, a future pledge's first meantime donation
// (with its scaled tip), or nothing for a future pledge without one.
export function chargeTodayCents({ future, amountCents, tipCents, trialAmountCents }) {
  if (!future) return amountCents + tipCents
  if (!trialAmountCents) return 0
  return trialAmountCents + scaledTipCents({ tipCents, planAmountCents: amountCents, trialAmountCents })
}
